module.exports = __webpack_public_path__ + "static/media/1.2ec115e8.jpg";